export const REQUEST_EMAIL_TEMPLATES_CONTENT =
  "REQUEST_EMAIL_TEMPLATES_CONTENT";
export const SET_EMAIL_TEMPLATES_CONTENT = "SET_EMAIL_TEMPLATES_CONTENT";
export const REVOKE_EMAIL_TEMPLATES_CONTENT = "REVOKE_EMAIL_TEMPLATES_CONTENT";
export const RESET_EMAIL_TEMPLATES_CONTENT = "RESET_EMAIL_TEMPLATES_CONTENT";

export const REQUEST_SMS_TEMPLATES_CONTENT = "REQUEST_SMS_TEMPLATES_CONTENT";
export const SET_SMS_TEMPLATES_CONTENT = "SET_SMS_TEMPLATES_CONTENT";
export const REVOKE_SMS_TEMPLATES_CONTENT = "REVOKE_SMS_TEMPLATES_CONTENT";
export const RESET_SMS_TEMPLATES_CONTENT = "RESET_SMS_TEMPLATES_CONTENT";

export const CHANGE_EMAIL_TEMPLATES_MODALS = "CHANGE_EMAIL_TEMPLATES_MODALS";

export const APPEND_EMAIL_TEMPLATES_DELETION_ARRAY =
  "APPEND_EMAIL_TEMPLATES_DELETION_ARRAY";
export const SUBTRACT_EMAIL_TEMPLATES_DELETION_ARRAY =
  "SUBTRACT_EMAIL_TEMPLATES_DELETION_ARRAY";

export const REQUEST_DELETE_SINGLE_TEMPLATE = "REQUEST_DELETE_SINGLE_TEMPLATE";
export const REVOKE_DELETE_SINGLE_TEMPLATE = "REVOKE_DELETE_SINGLE_TEMPLATE";
export const RESET_DELETE_SINGLE_TEMPLATE = "RESET_DELETE_SINGLE_TEMPLATE";
export const GRANT_DELETE_SINGLE_TEMPLATE = "GRANT_DELETE_SINGLE_TEMPLATE";

export const REQUEST_DELETE_TEMPLATE_ARRAY = "REQUEST_DELETE_TEMPLATE_ARRAY";
export const REVOKE_DELETE_TEMPLATE_ARRAY = "REVOKE_DELETE_TEMPLATE_ARRAY";
export const RESET_DELETE_TEMPLATE_ARRAY = "RESET_DELETE_TEMPLATE_ARRAY";
export const GRANT_DELETE_TEMPLATE_ARRAY = "GRANT_DELETE_TEMPLATE_ARRAY";

export const SET_ACTIVE_TEMPLATE_DELETION = "SET_ACTIVE_TEMPLATE_DELETION";
export const RESET_ACTIVE_TEMPLATE_DELETION = "RESET_ACTIVE_TEMPLATE_DELETION";

export const SET_ACTIVE_TEMPLATE_DISPLAY = "SET_ACTIVE_TEMPLATE_DISPLAY";
export const RESET_ACTIVE_TEMPLATE_DISPLAY = "RESET_ACTIVE_TEMPLATE_DISPLAY";
